'use client';

import { type ReactNode, useEffect, useState } from 'react';

/**
 * Mount children after first input or a long idle — not on first paint.
 * GTM/GA4 stay in layout <head>; this is only popups / badges / heavy widgets.
 */
export default function AfterIdle({
  children,
  timeoutMs = 12_000,
}: {
  children: ReactNode;
  timeoutMs?: number;
}) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let done = false;
    const enable = () => {
      if (done) return;
      done = true;
      setReady(true);
    };

    const events: Array<keyof WindowEventMap> = ['pointerdown', 'scroll', 'keydown', 'touchstart'];
    events.forEach((event) =>
      window.addEventListener(event, enable, { once: true, passive: true }),
    );
    const timeoutId = window.setTimeout(enable, timeoutMs);

    return () => {
      events.forEach((event) => window.removeEventListener(event, enable));
      window.clearTimeout(timeoutId);
    };
  }, [timeoutMs]);

  if (!ready) return null;
  return children;
}
